import React from "react";
import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const JunoTextarea = styled.textarea`
  display: block;
  width: 100%;
  padding: 0.25em 0.75em 0.25em 0.25em;

  border: 2px solid var(--juno-color-border);
  border-radius: 0;
  color: var(--juno-color-text);
  resize: vertical;

  font-size: var(--juno-font-size-body-sm);
  line-height: normal;
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
  }

  /* stylelint-disable property-no-vendor-prefix */
  -webkit-appearance: none;
  /* stylelint-enable property-no-vendor-prefix */

  &:focus-visible {
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
  }

  ${(props) =>
    props.error &&
    css`
      border-width: 4px;
      border-color: var(--juno-color-error);
    `};

  ${(props) =>
    props.disabled &&
    css`
      font-weight: bold;
      background: none;
      resize: none;
    `};
`;

function Textarea(props) {
  return <JunoTextarea {...props} />;
}

export default Textarea;
